import { Http } from './http';
import { getApigw } from '@/util/index.js';
// 药开开引流o2o环境
const o2oApigw = 'https://qao2o.apigw.qa.91jkys.com/';
// 判断当前是否药开开o2o环境
const apigw =
  location.href.indexOf('qa.91jkys.com/f2e/drugstore-prescription-admin-pc/qatest-qao2o') > -1 ? o2oApigw : getApigw();
export default {
  getGuideRoute: params => {
    return Http.get(`${apigw}api/saas_monomer_admin/1.0/guideRouteV2`, { params }); // 获取药店开通状态及跳转地址
  },
  registerForGuidance: params => {
    return Http.post(`${apigw}api/saas_monomer_admin/1.0/registerForGuidanceV2`, params); // 引流用户一键开店
  }
};
